import { Stack, Link, SvgIcon, Typography, Box } from '@mui/material';
import { RouterLink } from 'src/components/router-link';
import ArrowBackIcon from 'src/icons/untitled-ui/free/arrow-narrow-left';

const BackNavigation = ({ onBackClick, label, subLabel, extraContent }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: '100%', py: 0.5 }}
    >
      {/* Left side: Back + label + subLabel */}
      <Stack direction="row" alignItems="center" spacing={1} flexShrink={0}>
        <Link
          color="text.primary"
          component={RouterLink}
          underline="hover"
          sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={onBackClick}
        >
          <SvgIcon sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </SvgIcon>
          <Typography
            sx={{
              fontSize: {
                xs: '1rem',
                sm: '1.1rem',
              },
              fontWeight: 500,
              lineHeight: 1.5,
            }}
          >
            {label}
          </Typography>
        </Link>

        {subLabel && (
          <Typography
            color="text.secondary"
            sx={{
              fontSize: {
                xs: '0.9rem',
                sm: '1rem',
              },
              ml: 1,
            }}
          >
            {subLabel}
          </Typography>
        )}
      </Stack>

      {/* Right side: extraContent, full remaining width */}
      {extraContent && (
        <Box sx={{ flexGrow: 1, ml: 2, display: 'flex', justifyContent: 'flex-end' }}>
          {extraContent}
        </Box>
      )}
    </Stack>
  );
};

export default BackNavigation;
